import styled from "styled-components";
import { ScreenButton } from "../index.styles";
import { ScreenProps, screens } from "../../../mocks/humans";
import IconButton, { IconButtonThemes } from "../../../components/Button/IconButton";
import ManageChanges from "./ManageChanges";
import { ReactNode } from "react";
import { ObjectTypes, Scene } from "../../../types/scene";
import HumatarActions from "./navbarActions/humatar/HumatarActions";
import TextActions from "./navbarActions/text/TextActions";
import ShapesActions from "./navbarActions/shapes/ShapesActions";
import MediaActions from "./navbarActions/media/MediaActions";
import TrimAction from "./navbarActions/video/TrimAction";
type DynamicToolsProps = {
  currentScene: Scene;
  backgroundRef: boolean;
  handleTrimVideo: () => void;
};
type ToolbarProps = {
  activeScreen: ScreenProps;
  handleActiveScreen: (id: ScreenProps) => void;
  handleBackInHistory: () => void;
  handleForwardInHistory: () => void;
  currentHistoryIndex: number;
  historyLength: number;
  dynamicToolsProps: DynamicToolsProps;
};
export const Toolbar = ({
  activeScreen,
  handleActiveScreen,
  handleBackInHistory,
  handleForwardInHistory,
  currentHistoryIndex,
  historyLength,
  dynamicToolsProps,
}: ToolbarProps) => (
  <ToolbarWrapper>
    <ScreenButton>
      {screens.map(({ id, icon, type }) => (
        <IconButton
          key={id}
          iconButtonTheme={IconButtonThemes.Transparent}
          icon={icon}
          className={activeScreen === type ? "active" : "not-active"}
          onClick={() => handleActiveScreen(type)}
        />
      ))}
    </ScreenButton>
    <ToolbarRightSection>
      <ManageChanges
        back={handleBackInHistory}
        undo={handleForwardInHistory}
        currentHistoryIndex={currentHistoryIndex}
        historyLength={historyLength}
      />
      <DynamicTools {...dynamicToolsProps} />
    </ToolbarRightSection>
    <div></div>
  </ToolbarWrapper>
);

const DynamicTools = ({ currentScene, backgroundRef, handleTrimVideo }: DynamicToolsProps) => {
  const { slideBackgroundColor, backgroundAssetId, activeObjectId, objects } = currentScene || {};
  const activeObjectType = objects?.find((item) => item.object.id === activeObjectId)?.type;

  const getTabAction = {
    [ObjectTypes.avatars]: <HumatarActions />,
    [ObjectTypes.texts]: <TextActions />,
    [ObjectTypes.shapes]: <ShapesActions />,
    [ObjectTypes.media]: <MediaActions />,
  };

  const shouldShowTrimAction = backgroundRef && backgroundAssetId === 2 && !slideBackgroundColor;

  if (!objects || !activeObjectType) {
    return shouldShowTrimAction ? <TrimAction onClick={handleTrimVideo} /> : <></>;
  }

  return (
    <DynamicToolsWrapper onClick={(event) => event.stopPropagation()}>
      {getTabAction[activeObjectType]}
    </DynamicToolsWrapper>
  );
};

const ToolbarWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
// const ToolbarWrapperInner = styled.div``;
const ToolbarRightSection = styled.div`
  display: flex;
  gap: 20px;
  @media (max-width: 768px) {
    gap: 16px;
  }
`;
const DynamicToolsWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export default Toolbar;
